import { create } from "zustand"
import type { DashboardData } from "@/types/dashboard"
import { fetchDashboard } from "@/services/dashboard"

interface DashboardState {
  data: DashboardData | null
  isLoading: boolean
  error: string | null
  fetch: () => Promise<void>
}

export const useDashboardStore = create<DashboardState>((set) => ({
  data: null,
  isLoading: false,
  error: null,

  fetch: async () => {
    set({ isLoading: true, error: null })

    try {
      const response = await fetchDashboard()

      if (response.status !== 1) {
        throw new Error(response.message || "Failed to fetch dashboard data")
      }

      set({ data: response.data, isLoading: false })
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Failed to fetch dashboard"
      set({ error: message, isLoading: false })
    }
  },
}))
